// src/pages/Matriculas.js
import React from 'react';
import './Matriculas.css';

const Matriculas = () => {
  return (
    <div className="matriculas-container">
      <h1>Cadastro de Matrículas</h1>
      <p>Aqui você pode gerenciar as matrículas dos alunos.</p>
    </div>
  );
};

export default Matriculas;
